import { Howl } from 'howler'

const appFlowComponent = () => ({
  schema: {
    name: { type: "string", default: "jo-target" },
  },
  init() {
    // Cache DOM elements
    this.modelEntity = document.getElementById("model")
    this.instructionsPage = document.getElementById("instructions-page")
    this.instructionsButton = document.getElementById("instructions-button")
    this.scanPage = document.getElementById("scan-page")
    this.audioElement = document.querySelector('#audio')

    // Initial state
    this.el.setAttribute("visible", false)
    this.modelEntity.object3D.visible = false

    // Initialize sound with starting volume of 0
    this.revealSound = new Howl({
      src: [this.audioElement.getAttribute('src')],
      html5: true,
      loop: true,
      preload: true,
      volume: 0.1, // Start with volume at 0
      onload: () => {
        console.log('Audio loaded successfully')
      },
      onloaderror: (id, err) => {
        console.error('Audio loading error:', err)
      },
      onplayerror: (id, err) => {
        console.error('Audio play error:', err)
      }
    })

    // Event listeners
    this.el.addEventListener("xrimagefoundonce", this.reveal.bind(this))
    this.instructionsButton.addEventListener(
      "click",
      this.instructionsFinished.bind(this)
    )

    // Log when target is found/lost
    this.el.addEventListener("xrimagefound", () => {
      console.log(`Image target ${this.data.name} found!`)
    })

    this.el.addEventListener("xrimagelost", () => {
      console.log(`Image target ${this.data.name} lost`)
    })
  },

  remove() {
    // Clean up event listeners
    this.instructionsButton.removeEventListener("click", this.reveal.bind(this))
  },

  instructionsFinished() {
    this.instructionsPage.classList.remove("revealed")
    this.scanPage.classList.add("revealed")
    this.el.setAttribute("persistent-image-anchor", {
      enabled: true,
      name: this.data.name,
    })
    
    // Dispatch a custom event when instructions are finished
    window.dispatchEvent(new CustomEvent('instructionsFinished'))
  },

  reveal() {
    this.scanPage.classList.remove("revealed")
    this.el.setAttribute("visible", true)

    setTimeout(
      function () {
        this.modelEntity.object3D.visible = true
        this.modelEntity.dispatchEvent(new CustomEvent("reveal"))
        this.el.sceneEl.dispatchEvent(new CustomEvent("reveal"))
        if (this.revealSound && this.revealSound.state() === 'loaded') {
          console.log('Playing sound...')
          this.revealSound.play()
          // Gradually increase volume
          this.fadeInAudio()
        } else {
          console.warn('Sound not ready to play')
        }
      }.bind(this),
      100
    )
  },

  fadeInAudio() {
    const targetVolume = 0.5
    const duration = 3000 // 3 seconds fade-in
    const steps = 60 // Number of steps for smooth transition
    const volumeStep = targetVolume / steps
    const intervalTime = duration / steps
    let currentVolume = 0

    const fadeInterval = setInterval(() => {
      currentVolume += volumeStep
      if (currentVolume >= targetVolume) {
        this.revealSound.volume(targetVolume)
        clearInterval(fadeInterval)
      } else {
        this.revealSound.volume(currentVolume)
      }
    }, intervalTime)
  },
})

const imageAnchorComponent = () => ({
  schema: {
    name: { type: "string", default: "jo-target" },
    enabled: { type: "boolean", default: false },
  },
  init() {
    const { object3D } = this.el
    object3D.visible = false
    let foundOnce = false

    const showImage = function ({ detail }) {
      // log the name of the image found
      console.log("persistent image found", detail.name)
      const { name, enabled } = this.data
      if (name !== detail.name || !enabled) return

      if (!foundOnce) {
        this.el.dispatchEvent(new Event("xrimagefoundonce"))
      }
      foundOnce = true
      object3D.position.copy(detail.position)
      object3D.quaternion.copy(detail.rotation)
      object3D.scale.set(detail.scale, detail.scale, detail.scale)
      object3D.visible = true
    }.bind(this)

    const imageLost = (e) => {
      object3D.visible = false
    }
    this.el.sceneEl.addEventListener("xrimagefound", showImage)
    this.el.sceneEl.addEventListener("xrimageupdated", showImage)
    this.el.sceneEl.addEventListener("xrimagelost", imageLost)
  },
})

const SceneComponents = [
  { name: "app-flow", val: appFlowComponent() },
  { name: "persistent-image-anchor", val: imageAnchorComponent() },
]

export { SceneComponents }
